"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onEnter = exports.Products = void 0;
var _analyticsData = require("@ori/analytics-data");
var _editorialFetching = require("@ori/editorial-fetching");
var _featureToggles = require("@ori/feature-toggles");
var _productBox = require("@ori/product-box");
var _productList = require("@ori/product-list");
var _react = require("react");
var _reactCoolInview = require("react-cool-inview");
var _constants = require("../../../constants");
var _utils = require("../../../utils");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const onEnter = ({
  unobserve
}) => unobserve();
exports.onEnter = onEnter;
const Products = ({
  debug,
  modulePosition,
  mrpStatementEnabled,
  headline,
  hideRating,
  hideSubscription,
  productCodes,
  placement = _analyticsData.Placement.ProductSlider,
  className
}) => {
  const {
    isFeatureEnabled
  } = (0, _featureToggles.useFeatureToggles)();
  const {
    observe,
    inView
  } = (0, _reactCoolInview.useInView)({
    rootMargin: '50px',
    onEnter
  });
  const {
    isLoadingMore,
    loadMoreItems,
    products,
    isRefreshing
  } = (0, _editorialFetching.useGetEditorialProducts)({
    productCodes,
    enabled: inView
  });
  const loadedItemCount = products.length;
  const totalItemCount = productCodes.length;
  const renderItemComponent = (0, _react.useCallback)(({
    item: product,
    index
  }) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_productBox.ProductBox, {
    ...product,
    hideRating: hideRating,
    hideSubscription: !isFeatureEnabled(_constants.EditorialPageFeature.PersonalSubscriptions) || hideSubscription,
    mrpStatementEnabled: mrpStatementEnabled,
    analyticsData: {
      placement,
      position: index
    },
    withTranslationsProvider: false
  }, product.code), [hideRating, hideSubscription, isFeatureEnabled, mrpStatementEnabled, placement]);
  const productListHybridModeConfig = (0, _react.useMemo)(() => ({
    threshold: 11,
    type: 'HYBRID',
    carousel: {
      id: `editorials-product-carousel-${modulePosition}`
    }
  }), [modulePosition]);
  if (totalItemCount < 1) {
    return (0, _utils.renderOrThrowError)({
      debug,
      message: 'EditorialProductBoxCarousel must have at least one product.',
      modulePosition,
      layout: 'EditorialProductBoxCarousel'
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    ref: observe,
    className: className,
    "data-testid": _constants2.PRODUCTS,
    isList: totalItemCount >= productListHybridModeConfig.threshold,
    children: [headline ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Headline, {
      variant: "h4",
      component: "h2",
      children: headline
    }) : null, inView ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_productList.ProductList, {
      items: products,
      shouldRenderItemCount: false,
      renderItemComponent: renderItemComponent,
      mode: productListHybridModeConfig,
      totalItemCount: totalItemCount,
      loadedItemCount: loadedItemCount,
      loadMoreItems: loadMoreItems,
      isLoadingMore: isLoadingMore,
      withTranslationsProvider: false,
      isRefreshing: isRefreshing
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_productList.ProductListSkeleton, {
      items: [],
      shouldRenderItemCount: false,
      renderItemComponent: renderItemComponent,
      mode: productListHybridModeConfig,
      totalItemCount: totalItemCount
    })]
  });
};
exports.Products = Products;
